import { salesReprocessAxios } from '../config/axiosInstances';
import { ManagementReportEntry } from '../state/managementReport/types';

export interface ManagementReportRequest {
  countryAcronym: string;
  accountingDateRange: string;
}

export default class ManagementReportApi {
  static async getManagementReport(request: ManagementReportRequest) {
    return salesReprocessAxios.get<ManagementReportEntry[]>(`/conciliations/management-report`, {
      params: request,
    });
  }
}
